//@flow
import React, {type Node} from 'react';

type DropdownLabelProps = {|
  children: Node,
  dataTestName: string,
|};

export default function DropdownLabel({dataTestName, children}: DropdownLabelProps): Node {
  return (
    <label
      htmlFor={`${dataTestName}_dropdown`}
      id={`${dataTestName}_dropdown_label`}
    >
      {children}
    </label>
  );
}
